import { retreiveProductMetafields } from '../services/products';
import { addItemsToCart, onAddToCart as onAddToCartService } from '../services/cart';
import { isFinalSale, retrieveSku, formatPrice, isUnreturnable } from '../utils/product';
import { replaceWords } from '../services/filter-value';

const tabletMedia = window.matchMedia('screen and (max-width: 1024px)');

const IMAGE_MEDIA = {
  // media: imageWidth
  'max-width: 400px': 340,
  'max-width: 1024px': 500,
  'min-width: 1200px': 900
};

const FEATURED_IMAGE_MEDIA = {
  'max-width: 400px': 600,
  'max-width: 1024px': 750,
  'min-width: 1200px': 1100
};

export const attachProductItemEvents = (renderedState, containerEl, isRebuy) => {
  if (!containerEl) return;
  const containerWrapper = containerEl.closest(`[id^="section-wrapper-"]`);
  const layout = containerWrapper?.dataset?.productCardLayout || "layout_2";
  Object.keys(renderedState).forEach(productId => {
    const productItems = Array.from(
      containerEl.querySelectorAll(`[data-id="${productId}"]`)
    );
    if (!productItems.length) return;
    renderedState[productId]['elements'] = productItems;
    productItems.forEach(itemEl => {
      const cartBtn = itemEl.querySelector('[data-add-to-cart-action]');
      const productItemBody = itemEl.querySelector('.product-item__body');
      const backdrop = itemEl.querySelectorAll('.product-item__backdrop');
      const options = Array.from(itemEl.querySelectorAll('[data-option]'));
      const dropdownItems = Array.from(itemEl.querySelectorAll('[data-value]'));
      cartBtn.onclick = () => onAddToCart(
        cartBtn, 
        productId, 
        renderedState, 
        isRebuy, 
        itemEl
      );
      dropdownItems.forEach(dropItem => (
        dropItem.onclick = () => onSelectOption(
          dropItem, 
          productId, 
          renderedState, 
          layout,
          itemEl
        )
      ));
      backdrop.forEach(b => b.addEventListener('click', () => {
        options.forEach(opt => opt.classList.remove('active'));
        b.classList.remove('active');
        productItemBody.classList.remove('active');
      }));
      if (layout !== 'layout_2') {
        options.forEach(opt => (
          [opt, opt.nextElementSibling].forEach(el => (
            el.onclick = () => {
              opt.classList.toggle('active');
              backdrop.forEach(b => b.classList.toggle('active'));
            }
          ))
        ));
      } else {
        itemEl.querySelector('.product-item__btn-toolbar-toggle')
          ?.addEventListener('click', () => {
            productItemBody.classList.toggle('active');
          });
      }
    });
  });
};

const createImageMediaList = (image, featuredCard) => {
  const mediaMap = featuredCard ? FEATURED_IMAGE_MEDIA : IMAGE_MEDIA;
  const mediaList = Object.entries(mediaMap).map(([media, imageWidth]) => (
    `
      <source 
        srcset="${window.resizeImage(image, imageWidth)}" 
        media="(${media})"
      >
    `
  ));
  return mediaList.join('\n');
};

const getItemBodyTemplate = ({
  layout,
  product,
  isFeaturedCard,
  renderedState
}) => {
  const defaultVariantId = !product.options.length ? `?variant=${product.variants[0].id}` : '';
  const specialTagNewIn = product.tags ? product.tags.includes('newin') : '';
  const specialTagLimited = product.tags ? product.tags.includes('limitededition') : '';
  const options = createOptionsList(product);
  const isAvailable = product.available

  const currencyFormatter = (number) => {
    if (isNaN(number)) return number
    const currentPrice = +number;
    const priceWithoutDecimal = +currentPrice.toFixed(0)
    const formatedPrice = priceWithoutDecimal.toLocaleString()
    return formatedPrice
  };
  if (layout === 'layout_2') {
    return `
      <div class="product-item__body" style="--options-size:${options.length}">
        <a 
          href="/products/${product.handle}${defaultVariantId}" 
          class="product-item__link"
          title="Product link for ${product.title}"
          draggable="false"
        >
          ${renderImages(product.images, isFeaturedCard, product.title)}
        </a>
        <div class="product-item__backdrop product-item__backdrop-upper"></div>
        <div class="product-item__backdrop"></div>
        <div class="product-item__toolbar-wrapper">
          <div class="product-item__toolbar">
            ${renderVariantOptions(options, renderedState, layout)}
          </div>
          <button 
            class="product-item__cart-btn" 
            data-add-to-cart-action 
            data-layout-toggler
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M19.7526 10.0012H0.19657M9.97461 0.223145V19.7792" stroke="black"/>
            </svg>
            <span class="short">Add</span>
          </button>
          <button class="product-item__btn-toolbar-toggle" style="display: none;">
            <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.665364 0.875488L6.4987 7.58382L12.332 0.875488" stroke="black" stroke-width="0.8"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="product-item__footer" data-available="${isAvailable}">
        <span class="text upper-case sold-out">Sold Out</span>
        <a href="/products/${product.handle}${defaultVariantId}" class="product-item__link">
          <span class="product-title text">${replaceWords(product.title)}</span>
        </a>
        <div class="product-item__price-group">
          <div class="producti-item__price-inner">
            ${product.compareAtPrice 
              ? `
                <span class="product-price product-price--real">
                  $${currencyFormatter(product.compareAtPrice)}
                </span>
              `
              : ''
            }
            <span class="product-price text">${localizationCurrencyFormat.replace(/\{\{.*?\}\}/, currencyFormatter(product.price)).toUpperCase()}</span>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div class="product-item__body">
      ${product.compareAtPrice
        ? `<span class="product-item__tag">SALE</span>`
        : ''
      }
      <a href="/products/${product.handle}${defaultVariantId}" title="Product link for ${product.title}" class="product-item__link">
        ${renderImages(product.images, isFeaturedCard, product.title)}
        <div class="wishlist-engine" data-product_id="${product.id}" data-variant_id="${product.variants[0].id}" data-full_button="false" data-css="true"></div>
      </a>
      <div class="product-item__backdrop"></div>
      <div class="product-item__toolbar">
        ${renderVariantOptions(options, renderedState, layout)}
      </div>
      <button class="btn-add-to-cart ${options.length ? '' : 'btn-add-to-cart-visible'}" data-add-to-cart-action>
        Add to bag
      </button>
    </div>
    <div class="product-item__footer">
      <a href="/products/${product.handle}${defaultVariantId}" class="product-item__link" title="Product link for ${product.title}">
        <span class="product-title text">${replaceWords(product.title)}</span>
      </a>
      <div class="product-item__price-group">
        <div class="producti-item__price-inner">
        ${product.compareAtPrice 
          ? `
            <span class="product-price product-price--real">
              $${currencyFormatter(product.compareAtPrice)}
            </span>
          `
          : ''
        }
          <span class="product-price">${localizationCurrencyCode}${currencyFormatter(product.price)}</span>
        </div>
      </div>
    </div>
  `;
};

export const getProductItemBody = (
  product, 
  _index, 
  renderedState, 
  isFeaturedCard, 
  containerEl,
  className
) => {
  let layout;
  if (containerEl) {
    const sectionContainer = containerEl.closest(`[id^="section-wrapper-"]`);
    const isSearch = document.body.dataset.templateName === 'search';
    layout = sectionContainer?.dataset?.productCardLayout || 'layout_2';
    if (isSearch) {
      let searchLayout = document.querySelector(".header-wrapper").getAttribute('data-product-card-layout')
      layout = searchLayout || "layout_2"
    }
  }
  const productColor = product.variants[0].title.split(' / ')[0];
  const featuredClass = isFeaturedCard ? ' product-item--featured' : '';
  const layoutClass = layout ? ` product-item--${layout}` : '';
  const additionalClass = className ? ' ' + className : '';
  // Determine if any label uses secondary style for parent class and product has ITA tag
  const { primary, secondary, tertiary, quaternary } = window.productCardSettings?.productLabels || {};
  const hasSecondaryStyle = (primary?.style === 'secondary' || 
                           secondary?.style === 'secondary' || 
                           tertiary?.style === 'secondary' || 
                           quaternary?.style === 'secondary') && 
                           product.tags && product.tags.includes('ITA');
  const styleClass = hasSecondaryStyle ? ' product-item--label-secondary product-item__body--label-secondary' : '';

  setProductInitialState(product, renderedState);
  return `
    <div 
      class="product-item${featuredClass}${layoutClass}${additionalClass}${styleClass}" 
      data-id="${product.id}" 
      data-color="${productColor.toUpperCase()}"
    >
      ${getItemBodyTemplate({
        layout,
        product,
        isFeaturedCard,
        renderedState
      })}
    </div>
  `
};

const isVideoPlaying = (videoEl) => (
  videoEl.currentTime > 0 && 
  !videoEl.paused && 
  !videoEl.ended && 
  videoEl.readyState > videoEl.HAVE_CURRENT_DATA
);

// const toggleMobileVideo = (videoEl, productEl) => {
//   if (!tabletMedia.matches) return;
//   if (productEl.classList.contains('playing')) {
//     return videoEl.pause();
//   };
//   if (!isVideoPlaying(videoEl)) {
//     videoEl.play();
//   }
// }

const playVideo = (videoEl) => {
  if (!isVideoPlaying(videoEl) && !tabletMedia.matches) {
    videoEl.play();
  }
};

const pauseVideo = (videoEl) => {
  if (tabletMedia.matches) return;
  videoEl.pause();
};

const addAvailableColorsLabel = (metafields, renderedState) => {
  if (
    window.collectionSettings &&
    !window.collectionSettings.color_available
  ) {
    return;
  }
  metafields.forEach(meta => {
    const productEls = renderedState[meta.productId]?.elements;
    if (!productEls) return;
    if (!meta.metafields.metafield_product_handle) {
      return;
    }
    productEls.forEach(product => {
      const priceLabelGroup = product
      .querySelector('.product-item__price-group:not(.color-option)');
      if (!priceLabelGroup) return;
      const labelPosition = (
        window.collectionSettings?.color_available_message_position || 
        'beforeend'
      );

      let colorsLabel;
      if (meta.metafields.colors_available_message_meta) {
        colorsLabel = meta.metafields.colors_available_message_meta;
      } else if (window.collectionSettings?.metafield_available_color) {
        colorsLabel = window.collectionSettings.metafield_available_color;
      } else {
        const numberOfColors = meta.metafields.metafield_product_handle.split(',').length + 1;
        colorsLabel = `${numberOfColors} ${numberOfColors > 1 ? "Colors": "Color"}`;
      }
  
      priceLabelGroup?.insertAdjacentHTML(
        labelPosition, 
        `<div class="labels-wrapper"><a href="/products/${renderedState[meta.productId].productBody.handle}" title="Product link for ${product.title}">
          <span class="product-color-link text">
            ${colorsLabel}
          </span>
        </a></dvi>`
      );
      priceLabelGroup.classList.add('color-option')
    });
  })
};

const addNewLabel = (metafields, renderedState, products) => {
  metafields.forEach((meta) => {
    const activationDate = meta.metafields['activation_date'];
    if (!activationDate) return;

    const daysDifference = getDateDifference(activationDate);
    const labelTemplate = getLabelFromDateAndTag(daysDifference, meta.productId, products);
    if (!labelTemplate) return;
    
    const productEls = renderedState[meta.productId].elements;
    productEls.forEach(product => {
      const labelWrappers = product.querySelectorAll('.labels-new-wrapper');
      if (labelWrappers.length) return;
      const productBody = product.querySelector('.product-item__body');
      const productFooter = product.querySelector('.product-item__footer');
      productBody.insertAdjacentHTML('beforeend', labelTemplate);
      productFooter.insertAdjacentHTML('beforeend', labelTemplate);
    })
  })

} 

function getDateDifference(dateString) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const timeDifference = currentDate - inputDate;
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
  return daysDifference;
}

function getLabelFromDateAndTag(daysDifference, productId, products) {
  const productObject = products.find(product => product.id === productId);
  const productTags = productObject.tags || [];
  let labelText = '';
  let labelStyle = 'primary';
  let labelAlignment = 'right';
  const { primary, secondary, tertiary, quaternary } = window.productCardSettings?.productLabels || {};
  
  if (daysDifference < 22 && productTags.includes(primary?.tag)) {
    labelText = primary?.text;
    labelStyle = primary?.style || 'primary';
    labelAlignment = primary?.alignment || 'right';
  } else if (daysDifference < 31 && productTags.includes(secondary?.tag)) {
    labelText = secondary?.text;
    labelStyle = secondary?.style || 'primary';
    labelAlignment = secondary?.alignment || 'right';
  } else if (productTags.includes(tertiary?.tag)) {
    labelText = tertiary?.text;
    labelStyle = tertiary?.style || 'primary';
    labelAlignment = tertiary?.alignment || 'right';
  } else if (productTags.includes(quaternary?.tag)) {
    labelText = quaternary?.text;
    labelStyle = quaternary?.style || 'primary';
    labelAlignment = quaternary?.alignment || 'right';
  }

  if (!labelText) return null;

  return `
  <div class="labels-wrapper labels-wrapper--${labelStyle} labels-wrapper--align-${labelAlignment}" data-day-passed="${daysDifference}">
    <span class="label--text label--text--${labelStyle}">${labelText}</span>
  </div>
  `
}


export const renderVideos = async (products, renderedState) => {
  const metafields = await retreiveProductMetafields(products);
  addAvailableColorsLabel(metafields, renderedState);
  addNewLabel(metafields, renderedState, products)
  const productsWithVideo = [];
  metafields.forEach(meta => {
    if (!('metafield_video_url' in meta.metafields)) return;
    const { metafield_video_url } = meta.metafields;
    const productElements = renderedState[meta.productId]?.elements;
    if (!productElements) return;
    productElements.forEach(itemEl => {
      const videoUrlArr = metafield_video_url.split(',');
      let videoUrl = videoUrlArr.find(url => {
        let colorLabel = url.split('|')[0].toUpperCase();
        if (colorLabel.includes('-')) {
          return colorLabel.replace(/-/g, ' ').includes(itemEl.dataset.color);
        }
        return colorLabel.includes(itemEl.dataset.color);
      });
      if (!videoUrl) return;
      videoUrl = videoUrl.split('|')[1];
      const productItemBody = itemEl.querySelector('.product-item__body');
      const imagesContainer = productItemBody.querySelector('.product-item__link');
      if (imagesContainer.children.length > 1) {
        imagesContainer.children[1].remove();
      }
      // const videoLabelEl = document.createElement('div'); // Adds play btn on left up corner of product
      // videoLabelEl.className = 'product-item__label'; // Adds play btn on left up corner of product
      // videoLabelEl.innerHTML = `
      //   <svg class="product-item__icon product-item__icon--play" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon fill="none" stroke="#444" stroke-width="2" points="3 22 21 12 3 2"></polygon></svg>
      //   <svg class="product-item__icon product-item__icon--pause" stroke="#444" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>
      //   <span>Video</span>
      // `; // Adds play btn on left up corner of product
      const videoEl = document.createElement('video');
      videoEl.playsInline = true;
      videoEl.className = 'product-item__media product-item__media--video';
      videoEl.muted = true;
      videoEl.draggable = false;
      videoEl.src = videoUrl;
      videoEl.loop = true;
      videoEl.autoplay = false;
      videoEl.setAttribute('preload', 'auto');
      videoEl.setAttribute('type', 'video/mp4');
      // productItemBody.insertAdjacentElement('afterbegin', videoLabelEl);
      imagesContainer.insertAdjacentElement('beforeend', videoEl);
      // videoLabelEl.addEventListener('click', () => toggleMobileVideo(videoEl, itemEl));
      productItemBody.addEventListener('mouseenter', () => playVideo(videoEl, itemEl));
      productItemBody.addEventListener('mouseleave', () => pauseVideo(videoEl, itemEl));
      videoEl.addEventListener('play', () => onVideoPlay(itemEl));
      videoEl.addEventListener('pause', () => onVideoPause(itemEl));
      videoEl.addEventListener('contextmenu', e => e.preventDefault())
      productsWithVideo.push(itemEl);
    });
    createVideoObserver(productsWithVideo);
  });
};

const onVideoPlay = (productElement, videoLabelEl) => {
  const labelText = videoLabelEl?.querySelector('span');
  labelText && (labelText.innerHTML = 'Pause');
  productElement.classList.add('playing');
};

const onVideoPause = (productElement, videoLabelEl) => {
  const labelText = videoLabelEl?.querySelector('span');
  labelText && (labelText.innerHTML = 'Video');
  productElement.classList.remove('playing');
};

const observeVideos = (entries) => {
  if (!tabletMedia.matches) return;
  entries.forEach(entry => {
    const video = entry.target.querySelector('video');
    const isPlaying = isVideoPlaying(video);
    if (isPlaying && !entry.isIntersecting) {
      pauseVideo(video, entry.target);
    }
  });
};

const createVideoObserver = (productEls) => {
  const styles = getComputedStyle(document.documentElement);
  const [headerHeight] = styles.getPropertyValue('--header-height').split('px');
  const [filtersHeight] = styles.getPropertyValue('--filters-height').split('px');
  const observer = new IntersectionObserver(observeVideos, {
    rootMargin: `-${+headerHeight + +filtersHeight + 30}px`,
  });
  productEls.forEach((productEl) => observer.observe(productEl));
};

const renderImages = (images, featuredCard, productTitle) => 
  images.reduce((prevImg, { originalSrc }) => (
    prevImg + `
      <picture class="product-item__media product-item__media--image">
        ${createImageMediaList(originalSrc, featuredCard)}
        <img 
          class="product-item__media product-item__media--image"
          loading="lazy"
          srcset="${window.resizeImage(originalSrc, 800)}"
          alt="${productTitle || 'Product Image'}"
          width="100%"
          height="100%"
        >
      </picture>
    `
  ), '');

const sizeOrder = ["S", "M", "L", "XL", "XXL", "3XL"];

const renderVariantOptions = (options, renderedState, layout) => (
  options.reduce((optPrev, opt, optIndex, self) => {
    renderedState[opt.productId].options[opt.name] = null;
    const isLayout2 = layout === 'layout_2';
    const sortedValues = opt.values.sort((a, b) => {
      return sizeOrder.indexOf(a.value) - sizeOrder.indexOf(b.value);
    });
    const optionItems = sortedValues.reduce((valPrev, val) => {
      const disabledClass = (self.length === 1 && !val.available) ? ' disabled' : '';
      return valPrev + `
        <li
          class="product-item__dropdown__item${disabledClass}${isLayout2 ? ' Link Link--underline Link--underlineReverse' : ''}" 
          data-available="${val.available}"
          data-id="${val.id}"
          data-value="${val.value.toUpperCase()}"
        >
          ${isLayout2 ? val.value : `&nbsp;${val.value}&nbsp;`}
        </li>
      `;
    }, '');

    return optPrev + `
      <div class="product-item__option-wrapper">
        <button 
          class="product-item__option"
          ${(optIndex && !isLayout2) > 0 ? 'disabled' : ''} 
          data-option="${opt.name}"
        >
          <span>${opt.name}</span>
          ${!isLayout2 
            ? `
            <svg class="product-item__option__icon" role="presentation" viewBox="0 0 19 12">
              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
            </svg>
            `
            : ''
          }
        </button>
        <ul class="product-item__dropdown">
          ${optionItems}
        </ul>
      </div>
    `;
  }, '')
);

const getVariantByTitle = (variants, ...options) => (
  variants.find(variant => {
    if (!options.length && !variant.options.length) return true
    const title = variant.options.join(' ');
    const optionsStr = options.filter(Boolean).join(' ');
    if (!Boolean(optionsStr.match(/^\d+$/)) && /\d/.test(optionsStr)) {
      return title.toUpperCase().indexOf(optionsStr.toUpperCase()) > -1;
    }
    const selectedOptionRegex = new RegExp(`\\b(${optionsStr})\\b`, 'gi');
    return !!title.match(selectedOptionRegex);
  })
);

const updateAvailableVariants = (
  nextOptionContainer, 
  prevOptionName, 
  id, 
  renderedState
) => {
  if (!nextOptionContainer) return;
  const dropdownItems = Array.from(
    nextOptionContainer.nextElementSibling.querySelectorAll('[data-value]')
  );
  dropdownItems.forEach(dropItem => {
    const activeProdItem = renderedState[id];
    const previousSelectedOption = activeProdItem.options[prevOptionName];
    const nextOption = dropItem.dataset.value
    const variantByTitle = getVariantByTitle(
      activeProdItem.variants, 
      previousSelectedOption,
      nextOption
    );

    dropItem.classList[
      variantByTitle && (variantByTitle.quantityAvailable || variantByTitle.availableForSale) 
        ? 'remove' : 'add'
    ]('disabled');
  });
};

const enableNextOption = (prevOption, returnOnlyContainer) => {
  const nextOptionWrapper = prevOption.parentNode.nextElementSibling;
  if (!nextOptionWrapper) return;
  const nextOptionContainer = nextOptionWrapper.querySelector('[data-option]');
  if (returnOnlyContainer) {
    return nextOptionContainer;
  }
  nextOptionContainer.removeAttribute('disabled');
  return nextOptionContainer;
};

const setActiveVariant = (nextOption, id, renderedState) => {  
  if (nextOption && !renderedState[id].selectedVariant) return;
  const { variants, options } = renderedState[id];
  const variantByTitle = getVariantByTitle(
    variants, 
    ...Object.values(options)
  );
  if (!variantByTitle?.availableForSale && nextOption) {
    renderedState[id].options[nextOption.dataset.option] = null;
    renderedState[id].selectedVariant = null;
  }
  renderedState[id]['selectedVariant'] = variantByTitle;
};

const updateProductUrl = (nextOption, id, renderedState, productElement) => {
  if (nextOption || !renderedState[id].selectedVariant) {
    return;
  }
  Array.from(productElement.querySelectorAll('a')).forEach(el => {
    const url = new URL(el.href);
    const params = new URLSearchParams(url.search);
    params.set('variant', renderedState[id].selectedVariant.id);
    url.search = params.toString();
    el.setAttribute('href', url);
  });
  updateWishlistVariantId(renderedState[id].selectedVariant.id, productElement);
};

const updateWishlistVariantId = (variantId, productElement) => {
  const wishlistProductIds = window.wishlist_products_ids 
  ? Object.values(window.wishlist_products_ids).flatMap(product => product.variants).map(String) 
  : [];
  const wishlistElement = productElement.querySelector('.wishlist-engine');
  if(wishlistElement) {
    wishlistElement.setAttribute('data-variant_id', variantId);

    if (wishlistProductIds.includes(variantId)) {
      wishlistElement.setAttribute('data-added', true);
      changeSVGColor(true);
    }else {
      wishlistElement.setAttribute('data-added', false);
      changeSVGColor(false);
    }
  }

  function changeSVGColor (isAdded) {
    const svgElement = wishlistElement.querySelector('svg path');
    if (svgElement) {
      if (isAdded) {
        svgElement.style.fill = '#000';
      }else{
        svgElement.style.fill = 'none';
      }
    }
  }
}

const setProductInitialState = (product, renderedState) => {
  // to cache option selection
  renderedState[product.id] = {
    variants: product.variants,
    productBody: product,
    options: {},
    selectedVariant: product.variants.length === 1 ? product.variants[0] : null
  };
};

const onSelectOption = (item, productId, renderedState, layout, productElement) => {
  if (item.classList.contains('disabled')) {
    return;
  }
  const optionContainer = item.parentNode.previousElementSibling;
  const { value: optionValue } = item.dataset;
  const { option: optionName } = optionContainer.dataset;
  renderedState[productId].options[optionName] = optionValue;
  const nextOption = enableNextOption(optionContainer, layout === 'layout_2');
  updateAvailableVariants(nextOption, optionName, productId, renderedState);
  setActiveVariant(nextOption, productId, renderedState);
  updateProductUrl(nextOption, productId, renderedState, productElement);
  const hasEmptyOption = !!getEmptyOptionName(productId, renderedState);
  const addToCartBtn = productElement.querySelector('[data-add-to-cart-action]');
  if (layout !== 'layout_2') {
    optionContainer.querySelector('span').innerHTML = optionValue;
    addToCartBtn.style.visibility = hasEmptyOption ? 'hidden' : 'visible';
  } else if (item?.parentNode) {
    const dropdownItems = Array.from(item.parentNode.children)
    dropdownItems.forEach(dropdownItem => {
      if (dropdownItem !== item) {
        dropdownItem.classList.remove('active');
      }
    });
    item.classList.add('active');
  }
};

const getEmptyOptionName = (id, renderedState) => {
  const optionKeys = Object.keys(renderedState[id].options);
  if (!optionKeys.length || renderedState[id].selectedVariant) return null;
  return optionKeys.find(
    (key) => !Boolean(renderedState[id].options[key])
  );
};

const setAddToCartLabel = (btn, label, fallbackLabel, noFallback) => {
  if (!btn) return;
  btn.classList.add('active');
  const shortLabelEl = btn.querySelector('span.short');
  let expandedText;
  if (shortLabelEl) {
    btn.querySelector('span.expanded')?.remove();
    expandedText = document.createElement('span');
    expandedText.textContent = label;
    expandedText.className = 'expanded';
    shortLabelEl.insertAdjacentElement('beforebegin', expandedText);
  } else {
    btn.textContent = label;
  }
  if (noFallback) return;
  setTimeout((btn) => {
    btn.classList.remove('active');
    if (expandedText) {
      expandedText.remove();
    } else {
      btn.textContent = fallbackLabel || 'Add';
    }
  }, 2000, btn);
};

const createOptionsList = (product) => (
  product.options.map(el => ({
    productId: product.id,
    name: el.name,
    values: el.values.map(value => {
      const { id, availableForSale, quantityAvailable } = product.variants.find(v => (
        !!v.options.find(opt => opt === value)
      )) || {};
      let variantAvailable = availableForSale;
      if (availableForSale === undefined) {
        variantAvailable = !!quantityAvailable;
      }
      return { value, id, available: variantAvailable };
    })
  })).filter(opt => opt.name.toUpperCase() !== 'COLOR')
);

const clearSelectedOptions = (renderedProductState) => {
  Object.keys(renderedProductState.options).forEach(optionName => {
    renderedProductState[optionName] = null;
  });
  if (renderedProductState.productBody.variants.length > 1) {
    renderedProductState.selectedVariant = null;
  }
  renderedProductState.elements.forEach(productEl => {
    productEl.querySelectorAll('.product-item__dropdown__item')
      .forEach(item => {
        item.classList.remove('active');
      });
  });
};

const onAddToCart = async (btn, id, renderedState, isRebuy, productElement) => {
  let bodyElement;
  if (
    btn.hasAttribute('data-layout-toggler') && 
    renderedState[id].productBody.variants.length > 1
  ) {
    bodyElement = productElement.querySelector('.product-item__body');
    const isToolbarActive = bodyElement.classList.contains('active');
    bodyElement.classList.toggle('active');
    if (!isToolbarActive) return;
  }

  const btnFallbackLabel = bodyElement ? 'Add' : undefined;

  const emptyOption = getEmptyOptionName(id, renderedState);
  if (emptyOption) {
    return setAddToCartLabel(btn, `Please, pick a ${emptyOption}`, 'Add');
  }
  const { selectedVariant } = renderedState[id];
  if (!selectedVariant) {
    return setAddToCartLabel(btn, 'Error, try again', 'Add');
  }

  const isCartPage = (/cart/i).test(document.body.dataset.templateName);

  const rebuyProperties = {
    _source: 'Rebuy',
    _widget_id: isCartPage ? 16874 : 17054,
    _attribution: isCartPage
      ? 'Rebuy Cart'
      : 'Rebuy Product Page'
  };
  let price = selectedVariant?.priceV2?.amount
  let compareAtPrice = selectedVariant?.compareAtPrice?.amount
  if (!price) {
    price = selectedVariant.price;
    compareAtPrice = selectedVariant.compareAtPrice
  }

  const items = [{
    id: selectedVariant.id,
    quantity: 1,
    properties: {
      _OriginalPrice: `$${(+price).toFixed(2)}`,
      _CompareAtPrice: compareAtPrice && `$${(+compareAtPrice).toFixed(2)}`,
      _ProductSku: retrieveSku(selectedVariant.sku),
      _productTitle: replaceWords(renderedState[id].productBody.title),
      ...(isRebuy ? rebuyProperties : {})
    }
  }];

  if (isFinalSale(price, compareAtPrice) || isUnreturnable(renderedState[id])) {
    items[0].properties['_finalSale'] = 'Final Sale';
    items[0].properties["_LPROP"] = 'Final Sale';
  }

  const { options } = renderedState[id].productBody;
  const colorOptionFiltered = options.length !== selectedVariant.options.length;
  const productOptions = [...options];
  if (colorOptionFiltered) {
    productOptions.unshift({ name: 'Color' });
  }
  productOptions.forEach((option, optIndex) => {
    const optionValue = selectedVariant.options[optIndex];
    if (optionValue) {
      items[0].properties[option.name] = optionValue;
    }
  });

  setAddToCartLabel(btn, 'Adding...', btnFallbackLabel);
  try {
    const response = await onAddToCartService(items, selectedVariant);
    if (response?.message) {
      setAddToCartLabel(btn, response.message, btnFallbackLabel);
      return;
    }
    clearSelectedOptions(renderedState[id]);
    setAddToCartLabel(
      btn, 
      bodyElement ? 'Added to cart' : 'Added!', 
      btnFallbackLabel
    );
    Object.keys(renderedState).forEach((key) => {
      Object.keys(renderedState[key].options).forEach(option => {
        renderedState[key][option] = null;
        renderedState[key].options[option] = null;
      });
      renderedState[key].selectedVariant = renderedState[key].variants.length === 1 ? renderedState[key].variants[0] : null
    })
  } catch (er) {
    setAddToCartLabel(btn, 'Please, try again', btnFallbackLabel);
    console.error(er);
  }
};